import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Utensils } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { NutritionModal } from './NutritionModal';

interface NutritionButtonProps {
  petId: string;
  petName: string;
}

export const NutritionButton = ({ petId, petName }: NutritionButtonProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setIsOpen(true)}
        className="flex items-center gap-2"
      >
        <Utensils className="h-4 w-4" />
        {t('nutrition.button')}
      </Button>

      <NutritionModal
        open={isOpen}
        onOpenChange={setIsOpen}
        petId={petId}
        petName={petName}
      />
    </>
  );
};
